import {
    EnvelopeIcon,
    LinkIcon,
    PhoneIcon,
    DocumentTextIcon,
} from '@heroicons/react/24/outline/index.js';
import SlackIcon from '../icons/SlackIcon.jsx';
import { stripTags, truncate } from '../../lib/Utils.js';
import EmailSettings from './EmailSettings.jsx';
import SmsSettings from './SmsSettings.jsx';
import WebhookSettings from './WebhookSettings.jsx';
import SlackSettings from './SlackSettings.jsx';
import CustomFieldSettings from './CustomFieldSettings.jsx';
import PhoneCallSettings from './PhoneCallSettings.jsx';
import InvoiceActionSettings from './InvoiceActionSettings.jsx';
import CustomFieldIcon from '~/components/icons/CustomFieldIcon.jsx';
import { FEATURE_INVOICES } from '~/lib/Features';

export const Actions = {
    email: {
        name: 'Email',
        settings: EmailSettings,
        icon: <EnvelopeIcon />,
        preview: settings => {
            return (
                <div>
                    <div>
                        Subject: {stripTags(settings?.subject) || 'No Subject'}
                    </div>
                    <div>To: {stripTags(settings?.to) || 'No Recipients'}</div>
                </div>
            );
        },
    },
    sms: {
        name: 'Text Message',
        settings: SmsSettings,
        icon: <PhoneIcon />,
        hide: ({isMarketingAutomation}) => isMarketingAutomation,
        preview: settings => {
            return `Message: ${stripTags(settings?.message) || 'No message'}`;
        },
    },
    webhook: {
        name: 'Webhook',
        settings: WebhookSettings,
        icon: <LinkIcon />,
        preview: settings => {
            return `URL: ${settings?.url}`;
        },
    },
    slack: {
        name: 'Slack',
        settings: SlackSettings,
        icon: <SlackIcon />,
        preview: settings => {
            return (
                <div>
                    <div>Message: {truncate(stripTags(settings?.slack_message), 150) || <span className="text-red-500">No message</span>}</div>
                </div>
            );
        },
    },
    custom_field: {
        name: 'Custom Field',
        settings: CustomFieldSettings,
        icon: <CustomFieldIcon className="w-4 h-4" />,
        hide: ({data}) => data?.flowable_type === 'App\\Models\\ClassInstance',
        preview: settings => {
            const targetType = settings?.target_type || 'client';
            const fieldCount = settings?.field_assignments?.length || 0;
            return `Set ${fieldCount} custom field${fieldCount > 1 ? 's' : ''} on ${targetType}`;
        },
        verb: 'Set'
    },
    phone_call: {
        name: 'Phone Call',
        settings: PhoneCallSettings,
        icon: <PhoneIcon />,
        hide: ({isMarketingAutomation}) => isMarketingAutomation,
        preview: settings => {
            return `Call: ${truncate(stripTags(settings?.message), 150) || <span className="text-red-500">No message</span>}`;
        },
    },
    create_invoice: {
        name: 'Invoice',
        settings: InvoiceActionSettings,
        icon: <DocumentTextIcon />,
        hide: ({isMarketingAutomation, isEnabled}) => isMarketingAutomation || !isEnabled(FEATURE_INVOICES),
        preview: settings => {
            const itemCount = settings?.line_items?.length || 0;
            const sendStatus = settings?.send_immediately ? 'and send' : 'as draft';
            return `Create invoice with ${itemCount} line item${itemCount !== 1 ? 's' : ''} ${sendStatus}`;
        },
        verb: 'Create'
    },
};
